import { ItemBase } from './base/item-base';

export class Item extends ItemBase { }